module.exports = __webpack_public_path__ + "img/Notebook-bro.76f656e1.svg";